import React from 'react';
import { LinearProgress } from '@totalsoft/rocket-ui';

function LinearProgressWrapper() {
  return <LinearProgress color='primary' sx={{ '&.MuiLinearProgress-root': { mb: 0, borderRadius: '100vw' } }} />;
}

export default LinearProgressWrapper;
